import { testimonials } from "@/mocks/site";
import SectionHeading from "@/components/feature/SectionHeading";
import Reveal from "@/components/base/Reveal";

export default function TestimonialSection() {
  return (
    <section className="border-y border-background-200 bg-background-100">
      <div className="mx-auto w-full px-4 py-16 md:px-6 md:py-20 lg:px-10">
        <SectionHeading
          eyebrow="TRUST"
          title="瓜友们怎么说"
          desc="投稿者是我们最重要的信息来源，也是我们最在意的保护对象。以下是部分匿名瓜友的反馈。"
          align="center"
        />

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {testimonials.map((item, index) => (
            <Reveal key={item.name} delay={index * 80} className="h-full">
              <figure className="flex h-full flex-col rounded-lg border border-background-300 bg-background-50 p-6">
                <i className="ri-double-quotes-l text-3xl text-primary-300" aria-hidden="true" />
                <blockquote className="mt-3 flex-1 text-sm leading-8 text-foreground-700">
                  {item.content}
                </blockquote>
                <figcaption className="mt-6 flex items-center gap-3 border-t border-background-200 pt-5">
                  <span className="flex h-10 w-10 items-center justify-center rounded-md bg-secondary-100 text-lg text-secondary-800">
                    <i className={item.avatar} aria-hidden="true" />
                  </span>
                  <span>
                    <span className="block text-sm font-medium text-foreground-900">{item.name}</span>
                    <span className="mt-0.5 block text-xs text-foreground-500">{item.role}</span>
                  </span>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}